import { render, staticRenderFns } from "./SyncReports.vue?vue&type=template&id=56323ba4&scoped=true&"
import script from "./SyncReports.vue?vue&type=script&lang=js&"
export * from "./SyncReports.vue?vue&type=script&lang=js&"
import style0 from "./SyncReports.vue?vue&type=style&index=0&id=56323ba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56323ba4",
  null
  
)

export default component.exports